export default __webpack_public_path__ + "static/media/reading_instructions.ce471e23.pdf";